var render, staticRenderFns
import script from "./VBtn.vue?vue&type=script&lang=js&"
export * from "./VBtn.vue?vue&type=script&lang=js&"
import style0 from "./VBtn.vue?vue&type=style&index=0&id=bc5c3004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5c3004",
  null
  
)

export default component.exports